import { Col, Row } from "antd";
import React, { useState } from "react";

import styles from "./myTemplatesDetails.module.css";
import { SubmitButton, TextComponent } from "../../../../components";
import { useLocation } from "react-router-dom";

import templateImage from "../../../../assets/templateImage.png";
import Modal from "../../../../components/modal/Modal";
import CopyLinkModal from "../../../../components/copyLinkModal/CopyLinkModal";

function MyTemplateDetails() {
  const {
    state: { data: templateData },
  } = useLocation();
  const [linkModalOpen, setLinkModalOpen] = useState(false);

  return (
    <>
      <Row
        className={styles.Cont}
        style={{ backgroundImage: `url(${templateData?.image})` }}
      >
        <Col className={styles.btnCont}>
          <SubmitButton title="Share" onClick={() => setLinkModalOpen(true)} />
        </Col>
      </Row>

      <CopyLinkModal
        isCopyModalOpen={linkModalOpen}
        setIsCopyModalOpen={setLinkModalOpen}
        link={templateData?.image}
      />
    </>
  );
}

export default MyTemplateDetails;
